type LocalSite = { properties?: { id?: string; newManualSite?: boolean } }

// A new manual site carries a client-generated id until the server creates it, so an id alone
// does not mean saved.
export const isUnsavedSite = (site: LocalSite) =>
  !site.properties?.id || !!site.properties?.newManualSite
